import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Link } from 'gatsby';
import {
  bindHover,
  bindMenu,
  usePopupState
} from 'material-ui-popup-state/hooks';
import Menu from 'material-ui-popup-state/HoverMenu';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  button: {
    fontSize: 14,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 1,
    lineHeight: 1.375,
    color: 'inherit',
    '&:hover': {
      color: theme.palette.primary.main,
      background: 'transparent',
      border: 'none'
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'transparent'
    },
    [theme.breakpoints.up('lg')]: {
      paddingRight: 0,
      paddingLeft: 0
    }
  },
  subItem: {
    '& a': {
      color: 'inherit',
      textDecoration: 'none'
    },
    '&:hover': {
      color: theme.palette.primary.main
    }
  }
}));

const DesktopHeaderSubMenu = ({ title, data }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const popupState = usePopupState({ variant: 'popover', popupId: 'subMenu' });

  return (
    <>
      <Button
        className={classes.button}
        aria-controls="submenu"
        aria-haspopup="true"
        {...bindHover(popupState)}
        endIcon={<ArrowDropDownIcon />}
      >
        {t(title)}
      </Button>
      <Menu
        {...bindMenu(popupState)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {data.map((item, indx) => {
          return (
            <MenuItem
              key={indx}
              className={classes.subItem}
              onClick={popupState.close}
            >
              <Link to={item.href}>{t(item.title)}</Link>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

DesktopHeaderSubMenu.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default DesktopHeaderSubMenu;
